import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.constructor";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import StyledLink, { HelperText, IconWrapper } from './Link.style';
import whiteListed from '../../../utils/whiteListed';
var domainRegEx = new RegExp('(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]');
var window = '';

var Link = function Link(_ref) {
  var children = _ref.children,
      color = _ref.color,
      href = _ref.href,
      target = _ref.target,
      type = _ref.type,
      home = _ref.home,
      underline = _ref.underline,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, ["children", "color", "href", "target", "type", "home", "underline", "icon"]);
  /**
   * If we haven't specifically set the target via props, check if
   * this is an internal link OR on our whitelist before making it a '_self' link
   */


  if (target === null) {
    var isExternalLink = domainRegEx.test(href);
    var isWhiteListed = whiteListed(href);
    window = !isExternalLink || isWhiteListed ? '_self' : '_blank';
  } else {
    window = target === 'blank' ? '_blank' : '_self';
  }

  var hasIcon = icon !== null;
  return React.createElement(StyledLink, Object.assign({}, rest, {
    color: color,
    href: href,
    target: window,
    type: type,
    underline: underline
  }), children, target === 'blank' && React.createElement(HelperText, null, "(opens in new window)"), hasIcon && React.createElement(IconWrapper, null, icon));
};

Link.defaultProps = {
  type: 'standard',
  color: 'red',
  target: null,
  home: false,
  underline: true,
  icon: null
};
export default Link;